var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.734,
    height: 5.357,
    viewBox: "0 0 21.734 5.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.245,462.163H20.489a1.254,1.254,0,0,0,1.245-1.245v-2.867a1.254,1.254,0,0,0-1.245-1.245H1.245A1.254,1.254,0,0,0,0,458.051v2.867A1.254,1.254,0,0,0,1.245,462.163Z",
    transform: "translate(0 -456.806)",
    fill: "#122d5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDashIcon);
export default __webpack_public_path__ + "static/media/blueDashIcon.cebb97c00ebeb1b080ec2059ee735571.svg";
export { ForwardRef as ReactComponent };